import React, { FC, useContext } from 'react'
import { Button, ButtonGroup, Icon, Segment } from 'semantic-ui-react'

import GlobalContext from '../../contexts/GlobalContext'
import { getColorCompletionRate, getUserIdentity } from '../../Utility'

type Props = {
  roomingList: any
  paxTotal: number
  bookingCompletionRateByPax: any
  handlePreCheckInModal: Function
  handleConfirmModal: Function
}

const BookingRoomingButtonList: FC<Props> = ({
  roomingList = [], 
  paxTotal = 0, 
  bookingCompletionRateByPax, 
  handlePreCheckInModal,
  handleConfirmModal
}) => {
  const [globalContext] = useContext(GlobalContext) as any
  const nbEmptyPax = paxTotal - roomingList.length

  return (
    <>
      {roomingList.map((rooming, index) => {
        const completionRate = bookingCompletionRateByPax?.[rooming.id]?.rate ?? 0
        return (
          <ButtonGroup className="btnGroup" key={index} style={{width: "100%"}}>
            <Button 
              style={{width: "85%"}} 
              icon 
              labelPosition="left" 
              className="btnStyle" 
              basic 
              color="black" 
              animated="vertical" 
              onClick={() => handlePreCheckInModal(index, rooming.id)}
            >
              <Icon style={{width: "17.5%"}} name="user" size="large"/>
              <Button.Content>
                <p style={{color: "black", marginBottom:"0px"}}>
                  {getUserIdentity(rooming.civility, rooming.lastName, rooming.society, rooming.firstName)}
                </p>
                <p style={{color: getColorCompletionRate(completionRate)}}>complété à {completionRate}%</p>
              </Button.Content>
            </Button>
            <Button 
              style={{width: "15%"}} 
              className="btnStyleDelete" 
              basic 
              color="black" 
              onClick={() => handleConfirmModal(index, rooming.id)}
            >
              <Icon style={{width: "15%"}} name="trash" size="large"/>
            </Button>
          </ButtonGroup>
        )
      })}
      {nbEmptyPax > 0 && Array.from(Array(nbEmptyPax))
        .map((_, index) => {
          return (
            <ButtonGroup className="btnGroup empty-pax" key={index} style={{width: "100%"}}>
              <Button 
                icon 
                labelPosition="left" 
                className="btnStyle" 
                color="black" 
                basic 
                animated="vertical" 
                onClick={() => handlePreCheckInModal()}
              >
                <Icon as={Icon} style={{width: "15%", color: "#fbbd08"}} name="add user" size="large"  />
                <Button.Content style={{color: "#fbbd08"}}>
                  {globalContext.translations.preCheckInAdd}
                </Button.Content>
              </Button>
            </ButtonGroup>
          )
        })
      }
    </>
  )
}

export default BookingRoomingButtonList